import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { ATLASENSE_PROVIDERS } from '../services';
import { DocumentViewerComponent } from './document-viewer.component';
import { CustomPipesModule } from '../custom-pipes/custom-pipes.module';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, CustomPipesModule],
  exports: [DocumentViewerComponent],
  declarations: [DocumentViewerComponent ],
})
export class DocumentViewerModule { }
